import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable, SelectSubscribe } from '@macs-frontend/decorators';
import { defaultUserPermissions, getUserPermissions } from '@macs-frontend/reducers/meta';
import { Store } from '@ngrx/store';

@Component({
  selector: 'md-module-switcher',
  templateUrl: './module-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModuleSwitcherComponent extends BaseComponent {
  @SelectSubscribe(getUserPermissions)
  userPermissions = defaultUserPermissions;

  constructor(
    private router: Router,
    readonly store$: Store<any>,
    readonly cdr: ChangeDetectorRef,
  ) {
    super();
    makeSelectable(this, { cdr, store$ });
  }

  navigate(route: string) {
    this.router.navigateByUrl(route);
  }

  close() {
    this.router.navigate([{ outlets: { modal: null } }]);
  }
}
